import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  title: string = '';
  description = [];
  isDismissible: boolean = false;
  show: boolean = false;
  success: boolean = false;
  timeout = null;
  get class() {
    return 'alert' + ' ' + (this.success === true ? 'alert-success' : 'alert-danger') + ' ' + (this.isDismissible === true ? 'alert-dismissible' : '');
  }

  constructor() { }

  showAlert(title, description: string, type) {
    //this.title = title;
    this.description = description.split("\n");

    if (this.timeout != null){
      clearTimeout(this.timeout);
      this.timeout=null;
    }

    this.show = true;
    if (type == 'error') {
      this.isDismissible = true;
      this.success = false;
    } else {
      this.isDismissible = false;
      this.success = true;
      this.timeout = setTimeout(() => { this.show = false }, 5000);
    }
  }

  closeAlert(){
    this.show=false;
  }
}
